import React, { Component } from 'react';
import PropTypes from 'prop-types';

import "./Accordion.scss";

import AccordionItem from './AccordionItem';

class Accordion extends Component {
  static propTypes = {
    children: PropTypes.instanceOf(Object).isRequired,
  };

  constructor(props) {
    super(props);

    const openItems = {};

    this.state = { openItems };
  }

  onClick = label => {
    const {
      state: { openItems },
    } = this;

    const isOpen = !!openItems[label];

    this.setState({
      openItems: {
        [label]: !isOpen
      }
    });
  };

  render() {
    const {
      onClick,
      props: { children, labelTag },
      state: { openItems },
    } = this;

    return (
      <div className="accordion">
        {React.Children.toArray(children).map(child => (
          <AccordionItem
            key={child.props.label}
            isOpen={!!openItems[child.props.label]}
            label={child.props.label}
            onClick={onClick}
            labelTag={labelTag}
          >
            {child.props.children}
          </AccordionItem>
        ))}
      </div>
    );
  }
}

export default Accordion;
